/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1LocationCountriesIdMutationResponse,
  DeleteApiV1LocationCountriesIdPathParams,
  DeleteApiV1LocationCountriesId401,
  DeleteApiV1LocationCountriesId404,
  DeleteApiV1LocationCountriesId500,
} from "../../types/locationCountryController/DeleteApiV1LocationCountriesId.ts";

function getDeleteApiV1LocationCountriesIdUrl(
  id: DeleteApiV1LocationCountriesIdPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/location/countries/${id}` as const,
  };
  return res;
}

/**
 * @description Tenta excluir permanentemente o país. Se houver dependências, o país é desativado (soft delete). **(Requer Authorization para autenticação)**
 * @summary Excluir país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:id}
 */
export async function deleteApiV1LocationCountriesId(
  id: DeleteApiV1LocationCountriesIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCountriesId401
      | DeleteApiV1LocationCountriesId404
      | DeleteApiV1LocationCountriesId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1LocationCountriesIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
